import React from "react";
import { Typography } from "antd";
import { cn } from "../../utils/cn";

const { Text } = Typography;

const CommonLoader = ({
    text = "Loading...",
    minHeight = "600px",
    className
}) => {
    return (
        <div className={cn(
            "flex flex-col items-center justify-center p-20 w-full",
            minHeight && `!min-h-[${minHeight}]`,
            className
        )}
            style={{ minHeight: minHeight }}
        >
            <div className="relative size-12 mb-4">
                <div className="absolute inset-0 rounded-full border-4 border-primary/10" />
                <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin" />
            </div>
            <Text type="secondary" className="animate-pulse font-medium">
                {text}
            </Text>
        </div>
    );
};

export default CommonLoader;
